/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/**
 * Defines the Design Language System (DLS) Material Expand Less Icon component.
 */
export const MaterialExpandLessIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path fillRule='evenodd' clipRule='evenodd' d='M4 14.9995L5.86667 16.8662L12 10.7329L18.1333 16.8662L20 14.9995L12 6.99954L4 14.9995Z' fill={iconColor} />
    </svg>
  );
};

export default MaterialExpandLessIcon;
